import type { FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import Dumbo from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import ImageIcon from '@wix/da-ds/pkg/Icons/24x24/AddImage';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import BaseCard from '../BaseCard';
import TierActionsDropdown from '../TierActionsDropdown';

import s from './TierCard.scss';

export interface Props {
  className?: string;
  tier: PapiDeviation;
  width: number;
  height: number;
  biData?: any;
}

const TierCard: FC<Props> = ({
  className,
  tier,
  width,
  height,
  biData,
}) => {
  const { t } = useTranslation();

  if (!tier) {
    return null;
  }

  const count = tier.tier?.stats?.deviations || 0;

  return (
    <BaseCard
      className={cn(s['root'], className)}
      width={width}
      height={height}
      biData={biData}
      thumb={
        tier.coverImage ? (
          <Dumbo
            deviation={tier.coverImage}
            height={height}
            width={width - 2} // Account for card borders
          />
        ) : (
          <div className={s['nopreview']}>
            <ImageIcon size={IconSize.MEDIUM} />
          </div>
        )
      }
      thumbClassName={s['thumb']}
      label={(
        <div className={s['complex-label']}>
          <span className={s['label-name']}>{tier.title}</span>
          <span className={s['label-size']}>
            {t('common.deviationCount', { count })}
          </span>
        </div>
      )}
      complexLabel
      href={Url.studioTier(tier.tier!.tierId!, 'deviations')}
      actionsWrapperClassName={s['actions-wrapper']}
      actions={<TierActionsDropdown tier={tier} className={s['actions']}/>}
    />
  );
};
TierCard.displayName = 'TierCard';

export default TierCard;
